import BaseAPI from "../api";

const path: string = "payment-channels";

export class PaymentChannelsApi extends BaseAPI {
 
  static createPaymentChannel(body: any): Promise<any> {
    return this.api.post(`${path}/create`, body);
  }

  static updatePaymentChannel(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}/updated`, body);
  }

  static getOne(id: number): Promise<any> {
    return this.api.get(`${path}/${id}/get-one`);
  }
  static deletePaymentChannel(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static getPaymentChannelList(query?: any): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }

  static uploadPaymentChannelFile(body: FormData): Promise<any> {
    return this.api.post(`${path}/upload-file`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}